export enum ICON_TYPE {
    CALENDAR = 'CALENDAR',
    RESET = 'RESET',
    DELETE = 'DELETE',
    PDF = 'PDF',
}
